import { ConsoleLogger } from '@app/lib/logger/ConsoleLogger';
import { Logger } from '@app/lib/logger/Logger';

declare global {
    // eslint-disable-next-line no-var
    var loggerGlobal: Logger | undefined;
}

function createLoggerInstance() {
    const loggerImplementation = process.env.NODE_ENV === 'development' ? new ConsoleLogger() : null;

    return new Logger(loggerImplementation);
}

export const logger = globalThis.loggerGlobal ?? createLoggerInstance();

if (process.env.NODE_ENV !== 'production') globalThis.loggerGlobal = logger;
